import { observer } from 'mobx-react-lite'
import { type OpportunitiesViewModel } from '@/features/opportunities/OpportunitiesViewModel'
import { OverachieverBanner } from '@/features/opportunities/components/OverachieverBanner'

export interface OverachieverBannerContainerProps {
  vm: OpportunitiesViewModel
}

export const OverachieverBannerContainer = observer(
  function OverachieverBannerContainer({
    vm,
  }: OverachieverBannerContainerProps) {
    return <OverachieverBanner workspaceText={vm.pickupLimitWorkspaceText} />
  },
)
